import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeadingModule } from '../../atoms/heading/heading.module';
import { ImageModule } from '../../atoms/image/image.module';
import { TextModule } from '../../atoms/text/text.module';
import { BannerAlertComponent } from './banner-alert.component';

@NgModule({
  imports: [CommonModule, ImageModule, HeadingModule, TextModule],
  declarations: [BannerAlertComponent],
  exports: [BannerAlertComponent]
})
export class BannerAlertModule {}
